// Hardcoded delegated vault mappings.
// Maps wallet address → list of vault subaccounts the user has been delegated to trade.
export const DELEGATED_VAULTS: Record<
  string,
  Array<{ subaccountAddress: string; label: string }>
> = {
  "0xd503b95164384a5ebbccbb5c4bdc8b4a5893d9651e9953abda8e1c22fcc1181d": [
    {
      subaccountAddress: "0xd6b4dccb59e8c9bd451e2e7d935039bef1e6de51ffbab2f77b1e9de73996b301",
      label: "DLP",
    },
  ],
};
